<template>
  <div class="zain-loading">
    <div class="zain-loading__container">
      <figure>
        <div class="dot white"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </figure>
      <p class="zain-loading__text">جاري التحميل...</p>
    </div>
  </div>
</template>

<script>
export default {
   name: 'AppLoading'
}
</script>

<style scoped>
.zain-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #034635 0%, #0d6650 30%, #309d81 60%, #409781 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.zain-loading__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

figure {
  position: relative;
  width: 6.250em;
  height: 6.250em;
  animation: rotate 2.4s linear infinite;
}

.white {
  top: 0; bottom: 0; left: 0; right: 0;
  background: white;
  animation: flash 2.4s linear infinite;
  opacity: 0;
}

.dot {
  position: absolute;
  margin: auto;
  width: 2.4em;
  height: 2.4em;
  border-radius: 100%;
  transition: all 1s ease;
}

.dot:nth-child(2) {
  top: 0;
  bottom: 0;
  left: 0;
  background: #004D4D;
  animation: dotsY 2.4s linear infinite;
}

.dot:nth-child(3) {
  left: 0;
  right: 0;
  top: 0;
  background: #4FD1C5;
  animation: dotsX 2.4s linear infinite;
}

.dot:nth-child(4) {
  top: 0;
  bottom: 0;
  right: 0;
  background: #004D4D;
  animation: dotsY 2.4s linear infinite;
}

.dot:nth-child(5) {
  left: 0;
  right: 0;
  bottom: 0;
  background: #4FD1C5;
  animation: dotsX 2.4s linear infinite;
}

.zain-loading__text {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-family: 'Zain', sans-serif;
  margin: 0;
  letter-spacing: 1px;
}

@keyframes rotate {
  0% { transform: rotate(0); }
  10% { width: 6.250em; height: 6.250em; }
  66% { width: 2.4em; height: 2.4em; }
  100% { transform: rotate(360deg); width: 6.250em; height: 6.250em; }
}

@keyframes dotsY {
  66% { opacity: .1; width: 2.4em; }
  77% { opacity: 1; width: 0; }
}

@keyframes dotsX {
  66% { opacity: .1; height: 2.4em; }
  77% { opacity: 1; height: 0; }
}

@keyframes flash {
  33% { opacity: 0; border-radius: 0%; }
  55% { opacity: .6; border-radius: 100%; }
  66% { opacity: 0; }
}
</style>
